/** Editable Form Field Names */
export const MODE = 'mode';
export const CAPPING_PERIOD = 'cappingPeriod';
export const CAPPING_MAX_ALLOWED = 'cappingMaxAllowed';
export const OPTIMIZE_PERIOD = 'optimizePeriod';
export const OPTIMIZE_MIN_ALLOWED = 'optimizeMinAllowed';
export const OPTIMIZE_MAX_ALLOWED = 'optimizeMaxAllowed';

export const MESSAGE_TYPES = 'messageTypes';

/** Static Field Names for Message Types */
export const ID = 'id';
export const INDEX = 'index';
export const NAME = 'name';
export const CHANNEL_NAME = 'channelName';
export const INITIAL_MODE = 'initialMode';
